import React, { Component } from 'react';
import moment from 'moment';
import _ from 'underscore';
import Messenger from '../../views/components/messenger.js';
import Timezone from '../Timezone.jsx';

export default class CheckableField extends Component {
  constructor(props) {
    super(props);

    this.state = this.parseInitialState(props.metadata);
    this.eventUpdate = this.eventUpdate.bind(this);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.parseInitialState(props.metadata));
  }

  UNSAFE_componentWillMount() {
    if (this.props.channel) {
      Messenger.on(`/${this.props.channel}`, this.eventUpdate);
    }
  }

  componentWillUnmount() {
    if (this.props.channel) {
      Messenger.off(`/${this.props.channel}`, this.eventUpdate);
    }
  }

  parseInitialState(metadata) {
    const keys = [
      'remoteError',
      'remoteValue',
      'remoteErrorAt',
      'remoteUpdatedAt',
    ];
    let state = {};

    if (Array.isArray(metadata)) {
      metadata = metadata.filter((meta) => !_.isEmpty(meta))[0];
    }

    keys.forEach((k) => {
      state[k] =
        _.isEmpty(metadata) || _.isEmpty(metadata[k]) ? '' : metadata[k];
    });

    return state;
  }

  parseEventUpdate(data) {
    const filtered = data.changes.filter((d) => {
      return (
        data.hostname === this.props.objectIdentifier &&
        d.property_id === this.props.propertyId
      );
    });

    if (filtered.length === 0) {
      return false;
    }
    return filtered[0].metadata;
  }

  eventUpdate(data) {
    const eventData = this.parseEventUpdate(data);

    if (!eventData) {
      return;
    }
    this.setState(
      this.parseInitialState({
        remoteError: eventData.remote_error,
        remoteValue: eventData.remote_value,
        remoteErrorAt: eventData.remote_error_at,
        remoteUpdatedAt: eventData.remote_updated_at,
      }),
    );
  }

  hasError() {
    if (!this.state.remoteErrorAt) {
      return false;
    }
    if (
      this.state.remoteUpdatedAt &&
      moment(this.state.remoteUpdatedAt).valueOf() >
        moment(this.state.remoteErrorAt).valueOf()
    ) {
      return false;
    }

    return true;
  }

  hasData() {
    if (this.hasError()) {
      return false;
    }
    if (
      _.isEmpty(this.state.remoteValue) ||
      _.isEmpty(this.state.remoteUpdatedAt)
    ) {
      return false;
    }

    return true;
  }

  render() {
    return (
      <div
        className={`CheckableFieldComponent ${this.hasError() ? 'hasError' : ''}`}
      >
        <If condition={!_.isEmpty(this.props.value)}>
          <div className='CheckableStatus'>
            <span className='CheckableLabel'>Configured Value: </span>
            <span className='CheckableContent value'>{this.props.value}</span>
          </div>
        </If>

        <If condition={this.hasError()}>
          <div className='CheckableStatus'>
            <span className='CheckableLabel'>Running Version: </span>
            <span className='CheckableContent CheckableError'>
              <a href={this.props.checkableLink}>{this.state.remoteError}</a>
            </span>
          </div>
          <div className='CheckableStatus'>
            <span className='CheckableLabel'>Last Checked: </span>
            <span className='CheckableContent'>
              <Timezone
                date={this.state.remoteErrorAt}
                format={'dddd, MMMM Do YYYY, h:mm:ss a z'}
                zones={['user']}
              />
            </span>
          </div>
        </If>

        <If condition={this.hasData()}>
          <div className='CheckableStatus'>
            <span className='CheckableLabel'>Running Version: </span>
            <span className='CheckableContent'>{this.state.remoteValue}</span>
          </div>
          <div className='CheckableStatus'>
            <span className='CheckableLabel'>Last Checked: </span>
            <span className='CheckableContent'>
              <Timezone
                date={this.state.remoteUpdatedAt}
                format={'dddd, MMMM Do YYYY, h:mm:ss a z'}
                zones={['user']}
              />
            </span>
          </div>
        </If>
      </div>
    );
  }
}
